import { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import ContactPage from "./ContactPage";
import "../styles/Section1.css";
import "../styles/Section2.css";
import "../styles/Section3.css";
import "../styles/Section4.css";
import "../styles/Section5.css";
import "../styles/Section6.css";
import "../styles/Section7.css";
import "../styles/Section8.css";
import "../styles/Section9.css";
import "../styles/Section10.css";
import "../styles/Section11.css";
import "../styles/Home.css";
import "../styles/Robust.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import HomeCarousel from "./Homecarousel/HomeCarousel";
import RobustTools from "./RobustTools";
import LotToOffer from "./LotToOffer/LotToOffer";
export default function HeaderImageTransition() {
  const navigate = useNavigate();

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };
  const testimonials = [
    {
      name: "KR Power Support",
      feedback:
        "Poster design fulfills our expectations. It perfectly matches the essence of our brand!",
      image: "/images/Company logoalter.webp"
    },
    {
      name: "DTDC",
      feedback:
        "The attendance app exceeded our expectations and met our requirements. It is user-friendly to use. So we are extremely happy with the results!",
      image: "/images/venkat.webp"
    },
    {
      name: "Nutrition Hub",
      feedback:
        "This app truly reflects our plan and expectations. It’s exactly what we visualized, we are extremely satisfied with the results!",
      image: "/images/gsd.webp"
    },
    {
      name: "SEO Ways",
      feedback:
        "We are extremely satisfied with this web design. It perfectly aligns with our expectations and requirements, reflecting exactly what we were hoping for!",
      image: "/images/Company logo1alter.webp"
    }
  ];

  const firstRowImages = [
    "/images/Company logo.webp",
    "/images/Company logo1.webp",
    "/images/Company logo2.webp",
    "/images/Company logo3.webp",
    "/images/Company logo4.webp",
    "/images/rob1.webp",
    "/images/rob2.webp",
    "/images/rob3.webp",
    "/images/rob4.webp",
    "/images/rob5.webp",
    "/images/rob6.webp",
    "/images/rob7.webp",
    "/images/rob8.webp",
    "/images/rob9.webp",
    "/images/rob10.webp",
    "/images/rob11.webp",
    "/images/Company logo5.webp",
    "/images/Company logo6.webp",
    "/images/Company logo7.webp",
    "/images/Company logo8.webp",
    "/images/Company logo9.webp",
    "/images/Company logo10.webp",
    "/images/Company logo11.webp",
    "/images/Company logo12.webp",
    "/images/Company logo13.webp",
    "/images/Company logo14.webp"
  ];

  const [visibleLogos, setVisibleLogos] = useState(8); // Start with 8 logos
  const [isLoading, setIsLoading] = useState(false);
  const observer = useRef();
  const loadingRef = useRef();

  const handleObserver = useCallback(
    (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && !isLoading) {
        setIsLoading(true);
        // Simulate network delay (remove in production)
        setTimeout(() => {
          setVisibleLogos((prev) => Math.min(prev + 4, firstRowImages.length));
          setIsLoading(false);
        }, 500);
      }
    },
    [isLoading]
  );

  useEffect(() => {
    if (loadingRef.current) {
      observer.current = new IntersectionObserver(handleObserver, {
        root: null,
        rootMargin: "20px",
        threshold: 0.1
      });
      observer.current.observe(loadingRef.current);
    }
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [handleObserver, visibleLogos]);

  const handleClicked = () => {
    navigate("/contact");
  };
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };
  return (
    <>
      <section className="container">
        <div
          className="header-content"
          initial="hidden"
          animate="show"
          variants={containerVariants}
        >
          <h1 className="hometitle" loading="eager">
            #1 Web & Mobile App Development Company in Salem
          </h1>

          <h2 className="hometitle1">
            Empowering Businesses with{" "}
            <span className="company-name">MPeoples</span>
          </h2>
          <HomeCarousel />
          <p className="hometitle2" style={{ willChange: "transform" }}>
            In today's digital age, a strong online presence and seamless mobile
            experience drive growth. Our team of experts has delivered projects,
            turning visions into high-performing digital solutions.
          </p>
        </div>
      </section>
      <section className="container">
        <motion.section
          className="m whychooseus"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="mb-4 fsh2">WHY CHOOSE US?</h2>
          <p className="mb-5 fsh3">
            Our values that inspire us to push forward every day.
          </p>
          <div className="row text-md-center text-start">
            {[
              {
                img: "/images/commitment.webp",
                title: "Commitment",
                desc: "Committed to customer satisfaction"
              },
              {
                img: "/images/excellence.webp",
                title: "Excellence",
                desc: "Building solutions that create rewarding results"
              },
              {
                img: "/images/passion.webp",
                title: "Passion",
                desc: "Constant iterative effort to make products better and more aligned with user needs."
              },
              {
                img: "/images/priority.webp",
                title: "Priority",
                desc: "Customer needs Customer satisfaction"
              }
            ].map((item, index) => (
              <motion.div
                className="col-12 col-sm-6 col-md-3 d-flex flex-column align-items-left align-items-md-center mb-3"
                key={index}
              >
                <div>
                  {/* Simplified version that definitely works: */}
                  <img
                    src={item.img}
                    alt={item.title}
                    className="mb-2 whychooseimg"
                    height="50"
                    width="50"
                    loading="lazy"
                  />
                  <h3 className="fs-h3 mb-2">{item.title}</h3>
                </div>
                <p className="text-muted fs-p">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>
      </section>
      <motion.section
        className="m align-items-center whychooseus"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2 className="mb2 fsh2">MEET OUR TEAM</h2>
        <div className="d-flex align-items-center justify-content-center">
          <motion.div
            className="row align-items-center thirdbox col-xl-7 col-md-10 col-sm-12 rounded"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Col
              md={4}
              className="text-center d-flex flex-column justify-content-around h-100"
            >
              <div className="getquotesection">
                <LazyLoadImage
                  src="/images/gif.webp"
                  alt="GIF"
                  className="img-fluid mb-3 meetourteam"
                  height="120px"
                  width="120px"
                  style={{ height: "120px" }}
                />
                <button
                  className="button meetouteambtn"
                  onClick={handleClicked}
                >
                  <span className="text1">Get Quote &rarr;</span>
                  <div className="circle1"></div>
                </button>
              </div>
              <div>
                <img
                  src="/images/flag.webp"
                  alt="Flag"
                  className="img-fluid"
                  height="200px"
                  width="200px"
                  style={{ height: "200px" }}
                  loading="lazy"
                />
              </div>
            </Col>
            <Col
              md={8}
              className="text-center text-md-start d-flex flex-column justify-content-center meetaurteam"
            >
              <h1 className="fsh3 mb2 tl">
                Take your business to the next level of success
              </h1>
              <p className="fsp tl">
                We are a dynamic Website and Mobile Development company in
                Salem. Our team is propelled by innovation & collaboration. Our
                agile website developers and imaginative designers break
                boundaries, set benchmarks, and deliver customized business
                solutions.
              </p>
              <div className="d-flex flex-column align-items-start mt-4">
                {[
                  "All services in one place",
                  "Highly skilled in-line team",
                  "On-time delivery"
                ].map((text, index) => (
                  <motion.div
                    className="d-flex align-items-center mb-2"
                    key={index}
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.2 }}
                    viewport={{ once: true }}
                  >
                    <img
                      src="/images/tick.webp"
                      alt="Tick"
                      className="me-2"
                      height="20px"
                      width="20px"
                      style={{ width: "20px" }}
                    />
                    <span className="fw1">{text}</span>
                  </motion.div>
                ))}
              </div>
            </Col>
          </motion.div>
        </div>
      </motion.section>
      <LotToOffer />
      <motion.section
        className="sec9 m"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h2 className="fsh2 m0 mb1" variants={fadeInUp}>
          Our Achievement
        </motion.h2>
        <motion.p className="fsp m0 mb1" variants={fadeInUp}>
          We have successfully delivered innovative web and mobile solutions
          across various industries. From dynamic websites to feature-rich
          mobile applications, our expertise ensures high performance,
          scalability, and user engagement. Our commitment to quality and
          customer satisfaction has earned us industry recognition, long-term
          client trust, and successful digital transformations for businesses
          worldwide.
        </motion.p>
        <motion.div className="row justify-content-center mb1">
          {[
            "Successful Project Deliveries",
            "Client Satisfaction & Trust",
            "Seamless User Experiences"
          ].map((service, index) => (
            <motion.div
              key={index}
              className="col-md-4 d-flex align-items-center justify-content-md-center text-md-center text-start"
              variants={fadeInUp}
            >
              <img
                src="/images/tick.webp"
                alt=""
                className="tbus"
                height="30px"
                width="30px"
              />
              <span className="fw1">{service}</span>
            </motion.div>
          ))}
        </motion.div>
        <motion.button
          className="button"
          onClick={handleClicked}
          variants={fadeInUp}
        >
          Let's Talk &rarr;
        </motion.button>
      </motion.section>
      <section className="tgs">
        <h2 className="fw-bold m0 mb2 fsh2">THE GREATEST CLIENTS</h2>
        <div className="d-flex flex-column gap-4 overflow-hidden mb2">
          <div className="scroll-row left-to-right">
            {firstRowImages.slice(0, visibleLogos).map((image, index) => (
              <div
                className="p-1 border rounded shadow-sm bg-white sector7class"
                key={`logo-${index}`}
              >
                <img
                  className="sector7image"
                  src={image}
                  alt={`Client ${index + 1}`}
                  loading="lazy"
                  width="80"
                  height="50"
                />
              </div>
            ))}
          </div>

          {/* Loading trigger */}
          {visibleLogos < firstRowImages.length && (
            <div ref={loadingRef} className="text-center py-3">
              {isLoading ? (
                <div className="spinner-border text-secondary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <span className="text-muted">Scroll to load more</span>
              )}
            </div>
          )}
        </div>
      </section>
      <section className="m whychooseus">
        <h2 className="fsh2 m0 mb2">THE GREATEST CLIENTS SAYS</h2>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          navigation
          pagination={{ clickable: true }}
          className="p-2"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div
                className="card border-0 p-4 text-center mb-4"
                style={{
                  position: "relative",
                  zIndex: "1",
                  marginTop: "10px",
                  boxShadow: "rgba(67, 123, 176, 0.5) 4px 4px 10px"
                }}
              >
                <div className="d-flex flex-column align-items-center">
                  <div
                    className="rounded-circle overflow-hidden"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <img
                      src={testimonial.image}
                      className="img-fluid w-100 h-100 object-fit-contain"
                      alt={testimonial.name}
                      loading="lazy"
                    />
                  </div>
                  <img
                    className="mt-2"
                    src="/images/quotes.webp"
                    alt="Quotes"
                    height="40px"
                    width="40px"
                    loading="lazy"
                    style={{ width: "40px" }}
                  />
                </div>
                <div className="mt-3" style={{ height: "160px" }}>
                  <p className="fst-italic">{testimonial.feedback}</p>
                  <p className="fw-bold">{testimonial.name}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className=" d-flex flex-column justify-content-md-center justify-content-start align-items-md-center align-items-start">
        <h2 className="fsh2 m0 mb2 ourpro">OUR PROCESS</h2>
        <div className="op">
          <div className="op1">
            <div className="op3">
              <div className="op2">
                <img
                  className="opimg"
                  src="/images/op1.webp"
                  alt=""
                  loading="lazy"
                  height="60px"
                  width="60px"
                />
              </div>
              <div className="spacing">
                <h2 className="fsh4">PREMIUM DEVELOPEMENT</h2>
                <p className="fsp spacing1">
                  An emphasis on cutting-edge design and modern usabilty
                  standards
                </p>
              </div>
            </div>
            <div className="op3">
              <div className="op2">
                <img
                  className="opimg"
                  src="/images/op2.webp"
                  alt=""
                  loading="lazy"
                  height="60px"
                  width="60px"
                />
              </div>
              <div className="spacing">
                <h2 className="fsh4">SUPER FLEXIBLE</h2>
                <p className="fsp spacing1">
                  Content moves freely across all screen resolutions and all
                  devices
                </p>
              </div>
            </div>
            <div className="op3">
              <div className="op2">
                <img
                  className="opimg"
                  src="/images/op3.webp"
                  alt=""
                  loading="lazy"
                  height="60px"
                  width="60px"
                />
              </div>
              <div className="spacing">
                <h2 className="fsh4">LESS MAINTENANCE</h2>
                <p className="fsp spacing1">
                  Because there will be only one layout which works for all sort
                  of devices
                </p>
              </div>
            </div>
          </div>
          <div>
            <img
              className="handsomeimg"
              loading="lazy"
              alt="Portrait of a handsome individual"
              srcSet="/images/handsome.webp 500w,
            /images/handsome.webp 300w"
              sizes="(max-width: 600px) 300px, 500px"
              src="/images/handsome-500.webp"
              width="500"
              height="700"
            />
          </div>
          <div className="op1">
            <div className="op3">
              <div className="op2">
                <img
                  className="opimg"
                  src="/images/op4.webp"
                  alt=""
                  loading="lazy"
                  height="60px"
                  width="60px"
                />
              </div>
              <div className="spacing">
                <h2 className="fsh4">RETINA READY</h2>
                <p className="fsp spacing1">
                  Devices show more pixels per square inch, resulting in sharper
                  images.
                </p>
              </div>
            </div>
            <div className="op3">
              <div className="op2">
                <img
                  className="opimg"
                  src="/images/op6.webp"
                  alt=""
                  loading="lazy"
                  height="60px"
                  width="60px"
                />
              </div>
              <div className="spacing">
                <h2 className="fsh4">EXCELLENT USER EXPERIENCE</h2>
                <p className="fsp spacing1">
                  You ensure your customers will get a consistent experience
                  across all devices
                </p>
              </div>
            </div>
            <div className="op3">
              <div className="op2">
                <img
                  className="opimg"
                  src="/images/op5.webp"
                  alt=""
                  loading="lazy"
                  height="60px"
                  width="60px"
                />
              </div>
              <div className="spacing">
                <h2 className="fsh4">USER-CENTRIC APPROACH</h2>
                <p className="fsp spacing1">
                  Intuitive interfaces designed to maximize engagement and
                  satisfaction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <RobustTools />
      <ContactPage />
    </>
  );
}
